import { render, staticRenderFns } from "./type_select.vue?vue&type=template&id=c629a7ba"
import script from "./type_select.vue?vue&type=script&lang=js"
export * from "./type_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports